import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IInputOptions } from '@modeso/types__aumico-lib-notes-be';
import { IInputOptionsDialogData } from '../../interfaces/input-options-dialog-data.interface';
import { InputOptionsFormComponent } from '../componentOptions/input-options/input-options.component';

@Component({
    selector: 'app-input-options-dialog',
    templateUrl: './input-options-dialog.component.html',
    styleUrls: ['./input-options-dialog.component.scss'],
})
export class InputOptionsDialogComponent implements OnInit {
    inputOptions: IInputOptions;
    isFormValid: boolean;
    constructor(
        private readonly dialogRef: MatDialogRef<InputOptionsFormComponent, IInputOptions | undefined>,
        @Inject(MAT_DIALOG_DATA) public data: IInputOptionsDialogData,
    ) {}

    ngOnInit(): void {}

    onFormChange(inputOptionsMappedValue: IInputOptions): void {
        this.inputOptions = inputOptionsMappedValue;
    }
    onSaveButtonClick(): void {
        this.dialogRef.close(this.inputOptions);
    }

    onFormStatusChange(isValid: boolean) {
        this.isFormValid = isValid;
    }
}
